import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const updateUserResponse = createApi(`UpdateUserResponseSlice`, "POST");

const UpdateUserResponseSlice = createSlice({
  name: 'UpdateUserResponseSlice',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateUserResponse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserResponse.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateUserResponse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default UpdateUserResponseSlice.reducer;
